"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getChainAPI = void 0;
const spl_token_1 = require("@solana/spl-token");
const web3_js_1 = require("@solana/web3.js");
const live_env_1 = require("@ledgerhq/live-env");
const errors_1 = require("@ledgerhq/errors");
// Naive mode, allow us to filter in sentry all this error comming from Sol RPC node
const remapErrors = e => {
    throw new errors_1.NetworkDown(e === null || e === void 0 ? void 0 : e.message);
};
function getChainAPI(config, logger) {
    const fetchMiddleware = logger === undefined
        ? undefined
        : (url, options, fetch) => {
            logger(url, options);
            fetch(url, options);
        };
    const connection = () => {
        return new web3_js_1.Connection(config.endpoint, {
            commitment: "finalized",
            fetchMiddleware,
            confirmTransactionInitialTimeout: (0, live_env_1.getEnv)("SOLANA_TX_CONFIRMATION_TIMEOUT"),
        });
    };
    return {
        getBalance: (address) => connection().getBalance(new web3_js_1.PublicKey(address)).catch(remapErrors),
        getLatestBlockhash: () => connection()
            .getLatestBlockhash()
            .then(r => r.blockhash)
            .catch(remapErrors),
        getFeeForMessage: (msg) => connection()
            .getFeeForMessage(msg)
            .then(r => r.value)
            .catch(remapErrors),
        getBalanceAndContext: (address) => connection().getBalanceAndContext(new web3_js_1.PublicKey(address)).catch(remapErrors),
        getParsedTokenAccountsByOwner: (address) => connection()
            .getParsedTokenAccountsByOwner(new web3_js_1.PublicKey(address), {
            programId: spl_token_1.TOKEN_PROGRAM_ID,
        })
            .catch(remapErrors),
        getStakeAccountsByStakeAuth: (authAddr) => connection()
            .getParsedProgramAccounts(web3_js_1.StakeProgram.programId, {
            filters: [
                {
                    memcmp: {
                        offset: 12,
                        bytes: authAddr,
                    },
                },
            ],
        })
            .catch(remapErrors),
        getStakeAccountsByWithdrawAuth: (authAddr) => connection()
            .getParsedProgramAccounts(web3_js_1.StakeProgram.programId, {
            filters: [
                {
                    memcmp: {
                        offset: 44,
                        bytes: authAddr,
                    },
                },
            ],
        })
            .catch(remapErrors),
        getStakeActivation: (stakeAccAddr) => connection().getStakeActivation(new web3_js_1.PublicKey(stakeAccAddr)).catch(remapErrors),
        getInflationReward: (addresses) => connection()
            .getInflationReward(addresses.map(addr => new web3_js_1.PublicKey(addr)))
            .catch(remapErrors),
        getVoteAccounts: () => connection().getVoteAccounts().catch(remapErrors),
        getSignaturesForAddress: (address, opts) => connection().getSignaturesForAddress(new web3_js_1.PublicKey(address), opts).catch(remapErrors),
        getParsedTransactions: (signatures) => connection()
            .getParsedTransactions(signatures, {
            maxSupportedTransactionVersion: 0,
        })
            .catch(remapErrors),
        getAccountInfo: (address) => connection()
            .getParsedAccountInfo(new web3_js_1.PublicKey(address))
            .then(r => r.value)
            .catch(remapErrors),
        sendRawTransaction: (buffer) => {
            return (0, web3_js_1.sendAndConfirmRawTransaction)(connection(), buffer, {
                commitment: "confirmed",
            }).catch(remapErrors);
        },
        findAssocTokenAccAddress: (owner, mint) => {
            return (0, spl_token_1.getAssociatedTokenAddress)(new web3_js_1.PublicKey(mint), new web3_js_1.PublicKey(owner))
                .then(r => r.toBase58())
                .catch(remapErrors);
        },
        getAssocTokenAccMinNativeBalance: () => (0, spl_token_1.getMinimumBalanceForRentExemptAccount)(connection()).catch(remapErrors),
        getMinimumBalanceForRentExemption: (dataLength) => connection().getMinimumBalanceForRentExemption(dataLength).catch(remapErrors),
        getEpochInfo: () => connection().getEpochInfo().catch(remapErrors),
        config,
    };
}
exports.getChainAPI = getChainAPI;
//# sourceMappingURL=index.js.map